import { Modal } from "@mui/material";
import {
  colorWhite,
  primaryColor,
} from "../../../../utility/constants/colorManager";
import ResizeListner from "../../../../utility/ResizeListner";

import CustomModalForConfirmation from "../../ui_comps/CustomModalForConfirmation";
import { CustomButton } from "../custom_button";
function ConfirmationModal({
  onclose,
  open,
  openConfirmModal,
  containerStyle,
  viewMoreStyle,
  onPressCancel,
  onPressOk,
  children,
}) {
  const { width, height } = ResizeListner();
  return (
    <CustomModalForConfirmation
      open={openConfirmModal}
      onClose={() => { }}
      // BackdropComponent={Backdrop}
      onBackdropClick={onPressCancel}
    >
      <div
        style={{
          width: children ? 500 : 300,
          height: children ? 200 : 150,
          backgroundColor: colorWhite,
          padding: "40px 30px 30px 30px",
          borderRadius: 15,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              fontSize: 16,
              fontWeight: "500",
            }}
          >
            {children ? children : "Do you want to close?"}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: 10,
          }}
        >
          <CustomButton
            title="Yes"
            styles={{
              width: "45%",
              backgroundColor: primaryColor,
              border: "none",
            }}
            textStyles={{
              color: colorWhite,
            }}
            onClick={onPressOk}
          />
          <CustomButton
            title="No"
            styles={{
              width: "45%",
              border: `1px solid ${primaryColor}`,
              backgroundColor: colorWhite,
            }}
            textStyles={{
              color: primaryColor,
            }}
            onClick={onPressCancel}
            backgroundColor="white"
            textColor={primaryColor}
          />
        </div>
      </div>
    </CustomModalForConfirmation>
  );
}

export default ConfirmationModal;
